import React from 'react'
import './notification.scss'
import { Constants, ImageConstants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import Loading from '../../common/loading/loading'
import Urls from '../../../apis/url'
import httpClient from '../../../apis/http-client'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component'
import HomeworkApi from '../../../apis/homework'

class HomeworkNotification extends React.Component {
  state = {
    loading: true,
    schoolDetails: {},
    isButtonClicked: false
  }

  constructor (props) {
    super(props)
    this.state.homeworkId = props.match.params.homeworkId
  }

  componentDidMount () {
    this.getHomeworkDetails()
  }

  getHomeworkDetails = _ => {
    const { homeworkId } = this.state
    const payload = {
      homeworkId
    }
    HomeworkApi.getHomeworkSchoolDetails(payload)
      .then(response => {
        this.setState({ schoolDetails: response, loading: false })
      })
      .catch(err => {
        this.setState({ schoolDetails: {}, loading: false })
      })
  }

  showToaster (type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster () {
    this.setState({
      showToaster: false
    })
  }

  sendHomeworkNotification = type => {
    const {homeworkId} = this.state;
    const payload = {
      type,
      homeworkId
    }
    this.setState({
      isButtonClicked: true
    })
    HomeworkApi.sendHomeworkNotification(payload).then(response => {
      // console.log(response);
      this.showToaster("info", "Students Notified Successfully")
      this.setState({
        isButtonClicked: false
      })
    }).catch(err => {
      // console.log(err);
      this.setState({
        isButtonClicked: false
      })
    })
  }

  render () {
    const {
      toasterMessage,
      toasterType,
      showToaster,
      schoolDetails
    } = this.state
    return (
      <>
        <div className='container-fluid hw-notification-component'>
          {this.state.loading && <Loading />}
          <div className='header row no-gutters'>
            <div className='col-12 text-right'>
              <img
                alt=''
                className='header-bg'
                src={getImageSource(ImageConstants.NOTIFICATION_HEADER_BG)}
              />
            </div>
          </div>

          <div className='row'>
            <div className='col'>
              {!this.state.loading && (
                <div className='notification-container'>
                  <div className='text-center'>
                    <img
                      alt=''
                      className='notification-banner'
                      src={getImageSource(ImageConstants.NOTIFICATION_BANNER)}
                    />
                  </div>
                  <div class='notification-details'>
                    <p className='success-message text-center'>
                      Hey! Notify your students about the homework.
                    </p>
                    <div className='text-center'>
                      {schoolDetails.homeworkNotification &&
                        schoolDetails.homeworkNotification.whatsapp && (
                          <button
                            className='cw-btn-md-v1 d-inline-block cw-btn-secondary mr-2'
                            onClick={() =>
                              this.sendHomeworkNotification('whatsapp')
                            }
                          >
                            Send Whatsapp Notification
                          </button>
                        )}
                      {schoolDetails.homeworkNotification &&
                        schoolDetails.homeworkNotification.pushNotification && (
                          <button
                            className={`cw-button-primary`}
                            onClick={() =>
                              this.sendHomeworkNotification('moengage')
                            }
                          >
                            Send Moengage Notification
                          </button>
                        )}
                    </div>
                    <p className='success-description text-center mt-5'>
                      For any further assistance or to implement Countingwell's
                      acclaimed Maths learning and formative assessment platform
                      to your school without increasing your workload or your
                      students' fee burden, contact us on <br />
                      <span><a href="mailto:schoolsupport@countingwell.com">schoolsupport@countingwell.com</a></span>
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {showToaster ? (
          <ToasterComponent
            message={toasterMessage}
            type={toasterType}
            position='bottom-center'
          />
        ) : (
          ''
        )}
      </>
    )
  }
}

export default HomeworkNotification
